/* eslint-disable max-len */
import React, { Fragment, useRef, useState } from 'react';
import moment from 'moment';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { formatNoticeTypeLabel } from '../noticeTypeUtils';

export default function UpdatesTable({ data, pageNumber, canEdit, canDelete, setConfirmationState, navigate, emptyScreenMessage, currentQuery = '' }) {
    const [selectedIndex, setSelectedIndex] = useState(null);
    const selectedRef = useRef(null);
    useOnClickOutside(selectedRef, () => setSelectedIndex(null));
    const querySuffix = currentQuery ? `?${currentQuery}` : '';

    return (
        <div className="-mx-1">
            <div className={`flex overflow-auto ${data.length < 10 ? 'pb-[100px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result">
                <table aria-label="Notices Table" className="w-full" id="admin-table">
                    <thead>
                        <tr>
                            <th className="w-[10%]"><span>Date</span></th>
                            <th className="w-[12%]"><span>Class</span></th>
                            <th className="w-[15%]"><span>Receiver</span></th>
                            <th className="w-[15%]"><span>Type</span></th>
                            <th className="w-[18%]"><span>Title</span></th>
                            <th className="w-[15%]"><span>Added by</span></th>
                            <th className="w-[5%]"><span className="flex items-center justify-center">Actions</span></th>
                        </tr>
                        <tr aria-colspan="7" className="h-1"></tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => {
                            const receiver = item.receiver_type === 'student'
                                ? item.student_name || '-'
                                : item.sections?.length > 0
                                    ? item.sections.map((section) => section.section_name).join(', ')
                                    : item.section_name || '-';
                            const descriptionTruncated = item.description?.length > 60
                                ? item.description.substring(0, 60) + '...'
                                : item.description;
                            const title = item.title || item.description || '-';
                            const titleTruncated = title.length > 45
                                ? title.substring(0, 45) + '...'
                                : title;
                            const viewPath = `/noticeboard/classroom/updates/view/${item._id}${querySuffix}`;
                            const editPath = `/noticeboard/classroom/updates/edit/${item._id}${querySuffix}`;

                            return (
                                <Fragment key={item._id}>
                                    <tr className="tbl-row cursor-pointer" onClick={() => navigate(viewPath)}>
                                        <td>{moment(item.date).format('MMM DD, YYYY')}</td>
                                        <td>{item.class_name}</td>
                                        <td title={receiver}>{receiver}</td>
                                        <td>
                                            <span className="capitalize">
                                                {item.notice_type_label || formatNoticeTypeLabel(item.notice_type)}
                                            </span>
                                        </td>
                                        <td title={title}>{titleTruncated}</td>
                                        <td>{item.created_by_name || '-'}</td>
                                        <td className="prevent-click" onClick={(e) => e.stopPropagation()}>
                                            <div className="relative flex items-center justify-center prevent-click">
                                                <button
                                                    type="button"
                                                    className="list-more-btn prevent-click"
                                                    onClick={() => setSelectedIndex(selectedIndex === index ? null : index)}
                                                >
                                                    <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="actions" className="prevent-click" />
                                                </button>
                                                {selectedIndex === index && (
                                                    <ul
                                                        ref={selectedRef}
                                                        className={`${(index + 1 === 10 || index + 2 === 10) ? 'top3' : ''} list-more-optns-div [&[data-te-dropdown-show]]:block prevent-click`}
                                                    >
                                                        <li>
                                                            <button
                                                                type="button"
                                                                className="list-more-optns prevent-click"
                                                                onClick={() => {
                                                                    navigate(viewPath);
                                                                    setSelectedIndex(null);
                                                                }}
                                                            >
                                                                View Details
                                                            </button>
                                                        </li>
                                                        {canEdit(item) && (
                                                            <li>
                                                                <button
                                                                    type="button"
                                                                    className="list-more-optns prevent-click"
                                                                    onClick={() => {
                                                                        navigate(editPath);
                                                                        setSelectedIndex(null);
                                                                    }}
                                                                >
                                                                    Edit
                                                                </button>
                                                            </li>
                                                        )}
                                                        {canDelete(item) && (
                                                            <li>
                                                                <button
                                                                    type="button"
                                                                    className="list-more-optns prevent-click"
                                                                    onClick={() => {
                                                                        setConfirmationState({ item });
                                                                        setSelectedIndex(null);
                                                                    }}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </li>
                                                        )}
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                </Fragment>
                            );
                        })}
                    </tbody>
                    {data.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ lineHeight: '100px' }} colSpan="7" className="no-records-message" id="no-matching-result">
                                    {emptyScreenMessage || 'No matching records found.'}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}
